import React, { FC } from 'react'

import { IconUnifiedCommunicationProps } from './IconUnifiedCommunication.types'
import * as Styled from './styles/IconUnifiedCommunication.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUnifiedCommunication: FC<IconUnifiedCommunicationProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUnifiedCommunicationProps['size'],
  isResponsive = false,
}: IconUnifiedCommunicationProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m40.098 11.684.101-.649c.188-1.312-.668-2.558-.668-2.558a6.803 6.803 0 0 0-1.937-2A8.985 8.985 0 0 0 34.8 5.21a10.706 10.706 0 0 0-3.36-.32c-1.132.07-2.25.316-3.304.73a9.286 9.286 0 0 0-2.653 1.602 7.035 7.035 0 0 0-1.734 2.226 5.509 5.509 0 0 0-.543 2.64c.031.575.152 1.141.367 1.677a5.79 5.79 0 0 0 .871 1.484c.38.473.817.895 1.305 1.25.5.367 1.523.816 2.121 1.078-.777 1.832-2.594 2.91-2.594 2.91.75.063 1.508.032 2.25-.09A8.359 8.359 0 0 0 29.04 20c.82-.344 1.613-.742 2.379-1.191l.445-.25'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M42.984 34.426c.02.07.032.14.032.21a6.803 6.803 0 0 1-.305 1.938c-.75 2.438-2.773 5.051-5.164 5.75-6.031 1.797-12.383-.043-18-2.863A24.258 24.258 0 0 1 8.773 28.766c-2.832-5.594-4.68-11.914-2.875-17.914.715-2.375 3.352-4.391 5.793-5.137l1.957-.516a.64.64 0 0 1 .766.414l1.547 4.528c.789 2.203 1.578 4.406 2.363 6.609l.063.172a.753.753 0 0 1-.25.848 8.831 8.831 0 0 1-2.54 1.335c-1.09.336-2.21.551-3.347.645a.731.731 0 0 0-.621.945 24.544 24.544 0 0 0 6.02 9.95 24.795 24.795 0 0 0 10 6.015.731.731 0 0 0 .94-.62 15.54 15.54 0 0 1 .661-3.349 8.69 8.69 0 0 1 1.34-2.52.744.744 0 0 1 .86-.25l.167.06 6.637 2.351c1.574.559 2.918 1.121 4.5 1.684.09.03.18.27.23.41Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m40.86 11.879-.31-.09a8.28 8.28 0 0 0-2.609-.25 8.454 8.454 0 0 0-2.574.57 7.073 7.073 0 0 0-2.058 1.25 5.41 5.41 0 0 0-1.344 1.75 4.164 4.164 0 0 0 .203 4.043 5.31 5.31 0 0 0 1.5 1.567 6.94 6.94 0 0 0 2.172.98 8.181 8.181 0 0 0 2.613.25h.086a7.091 7.091 0 0 0 2.152.996 6.7 6.7 0 0 0 1.5.23 6.992 6.992 0 0 0 1.735-.144s-1.82-1.054-1.875-2.144c.433-.25.836-.551 1.203-.89a5.56 5.56 0 0 0 .898-1.083 4.64 4.64 0 0 0 .551-1.23 4.15 4.15 0 0 0-.473-3.32 4.928 4.928 0 0 0-.917-1.114 8.58 8.58 0 0 0-2.454-1.36'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconUnifiedCommunication
